export enum ActorType {
	ON_CHILD_ATTRIBUTE_UPDATE = 'onChildAttributeUpdate',
	ON_KEYDOWN = 'onKeydown',
	ON_KEYPRESS = 'onKeypress',
	ON_KEYUP = 'onKeyup',
	ON_SCENE_RESET = 'onSceneReset',
	ON_SCENE_PLAY_STATE = 'onScenePlayState',
	ON_TICK = 'onTick',
	ON_OBJECT_ATTRIBUTE_UPDATE = 'onObjectAttributeUpdate',
	ON_OBJECT_CLICK = 'onObjectClick',
	ON_OBJECT_HOVER = 'onObjectHover',
	ON_OBJECT_POINTER_DOWN = 'onObjectPointerDown',
	ON_OBJECT_POINTER_UP = 'onObjectPointerUp',
	ON_POINTER_UP = 'onPointerUp',
	RAY_FROM_CURSOR = 'rayFromCursor',
	// SET_OBJECT_HOVERED_STATE = 'setObjectHoveredState',
}
